const LANG_SLUG_KEY = "currentLang";
const LANG_SOURCE_KEY = "currentLangSource";
const USER_SOURCE = "user";

export const DEFAULT_LANG_SLUG = "en";
export const DEFAULT_LOCALE = "en-US";

export function getStoredLangSlug(): string | null {
    return localStorage.getItem(LANG_SLUG_KEY);
}

export function storeAutoLangSlug(slug: string): void {
    localStorage.setItem(LANG_SLUG_KEY, slug);
    localStorage.removeItem(LANG_SOURCE_KEY);
}

export function storeUserLangSlug(slug: string): void {
    localStorage.setItem(LANG_SLUG_KEY, slug);
    localStorage.setItem(LANG_SOURCE_KEY, USER_SOURCE);
}

export function isLangChosenByUser(): boolean {
    return localStorage.getItem(LANG_SOURCE_KEY) === USER_SOURCE;
}

export function localeToSlug(locale: string | null | undefined): string | null {
    if (!locale) {
        return null;
    }

    const twoLetter = locale.trim().toLowerCase().split(/[-_]/)[0];
    return twoLetter === "he" || twoLetter === "en" ? twoLetter : null;
}

export function getCurrentLocale(): string {
    return getStoredLangSlug() === "he" ? "he-IL" : DEFAULT_LOCALE;
}
